import queryString from 'query-string';

import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import { APPLICATION_TYPE } from '@shared/constants';
import useBetaFeatureEnabled from './useBetaFeatureEnabled';

export const useAppNameParameter = ({ parameterName = 'from' } = {}) => {
  const { [parameterName]: from } = queryString.parse(window.location.search);
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);

  if (!isLLMEvalEnabled) {
    return APPLICATION_TYPE.em;
  }

  return typeof from === 'string' && from.toUpperCase() === APPLICATION_TYPE.llm
    ? APPLICATION_TYPE.llm
    : APPLICATION_TYPE.em;
};
